// extracted by css-extract-rspack-plugin
export default {"title":"title-a03geS","value":"value-oSgk7f","rows":"rows-im8FNG","row":"row-GI85LU"};